
import { useNavigate } from "react-router-dom";
import { InstrumentAmountDTO, PieceResponseDTOSimple } from "../../openapi-generated-client";
import PieceIconDisplay from "../../pages/pieces/pieceIconDisplay";
import PieceIconDisplayMobile from "../../pages/pieces/pieceIconDisplayMobile";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { useSafeNavigate } from "../unloadBlocker";
import DifficultyDisplay from "./difficultyDisplay";
import InstrumentDisplay, { OrchestraInstrumentDisplay } from "./instrumentDisplay";
import "./pieceDisplay.css";
import PiecePreview from "./piecePreviews";
import LinkIcon from "../../assets/icons/linkIcon";

const MAX_INSTRUMENTS_DISPLAYED = 8;

interface PieceDisplayProps {
    pieceData?: PieceResponseDTOSimple;
    hideInstrumentation?: boolean;
    hideInfos?: boolean;
    hideIconDisplay?: boolean;
    hideComposer?: boolean;
    linkPrefix?: string;
    contributionType?: string;
    displayIfNotConfirmed?: boolean;
}

export default function PieceDisplay(props: PieceDisplayProps) {

    const navigate = useSafeNavigate(useNavigate());

    const windowDimensions = useWindowDimensions();

    if(props.pieceData == undefined) return <></>;

    var currentInstrument = 0;

    const instrumentsWithAmount = props.pieceData.instruments;

    if(windowDimensions.width < 900) {
        return <a href={props.linkPrefix + "/" + props.pieceData?.id} className="piece-display-link">
            <div className={"piece-display mobile" + (!props.pieceData.confirmed && props.displayIfNotConfirmed != false ? " not-confirmed" : "")}>
                {props.contributionType ? <div className="contribution-type">
                    <span>{props.contributionType}</span></div> : <></>}
                <PiecePreview fixedAspectRatio={10/12} thumbnailHash={props.pieceData.thumbnailHash}>
                    <div className="mobile-title-view">
                        {!props.hideInfos ? <div className="infos">
                            <h5 className="round-button active">{props.pieceData.price > 0 ? props.pieceData.price + " €" : "Free"}</h5>
                            <DifficultyDisplay concert={props.pieceData.difficulty == 1}/>
                        </div> : <></>}
                        <div className="titles">
                            <h2>{props.pieceData.title}</h2>
                            <a>{props.pieceData.author}<a className="grey">{props.pieceData.realComposer}</a></a>
                        </div>
                    </div>
                </PiecePreview>
                {!props.hideIconDisplay ? <PieceIconDisplayMobile downloads={props.pieceData.downloads}
                        likes={props.pieceData.likes}
                        duration={props.pieceData.duration}
                        year={props.pieceData.year}
                        original={props.pieceData.original}/> : <></>}
                
                {!props.hideInstrumentation ? <div className="instruments">
                    {instrumentsWithAmount.map(function (instrument: InstrumentAmountDTO){
                        var amount = instrument.amount;
                        return <InstrumentDisplay small instrument={instrument.instrument} amount={amount}/>;
                    })}
                    {(props.pieceData.orchestralInstruments?.length ?? 0) > 0 && <OrchestraInstrumentDisplay/>}
                </div> : <></>}
            </div>
        </a>;
    }

    return <a href={props.linkPrefix + "/" + props.pieceData?.id} className="piece-display-link">

        <div title={!props.pieceData.confirmed ? "Waiting for confirmation" : ""} className={"piece-display" + (!props.pieceData.confirmed && props.displayIfNotConfirmed != false ? " not-confirmed" : "")}>
                {props.contributionType ? <div className="contribution-type">
                    <span>{props.contributionType}</span></div> : <></>}
            <PiecePreview fixedAspectRatio={10/12} thumbnailHash={props.pieceData.thumbnailHash}>
                {!props.hideIconDisplay ? <PieceIconDisplay downloads={props.pieceData.downloads}
                    likes={props.pieceData.likes}
                    duration={props.pieceData.duration}
                    year={props.pieceData.year}
                    original={props.pieceData.original}/> : <></>}
                {props.pieceData.externalPiece && <div className="external-piece-indicator">
                    <div className="triangle"/>
                    <LinkIcon/>
                </div>}
            </PiecePreview>
            <h2>{props.pieceData.title}</h2>
            {!props.hideComposer ? <a>{props.pieceData.author}<a className="grey">{props.pieceData.realComposer}</a></a> : <></>}
            {!props.hideInfos ? <div className="infos">
                <span>{props.pieceData.price > 0 ? props.pieceData.price + " €" : "Free"}</span>
                <DifficultyDisplay concert={props.pieceData.difficulty == 1}/>
            </div> : <></>}
            {!props.hideInstrumentation ? <div className="instruments">
                {instrumentsWithAmount.map(function (current: InstrumentAmountDTO){
                    if(currentInstrument >= MAX_INSTRUMENTS_DISPLAYED) return <></>;
                    currentInstrument++;
                    return <InstrumentDisplay small instrument={current.instrument} amount={current.amount}/>;
                })}
                {(props.pieceData.orchestralInstruments?.length ?? 0) > 0 && <OrchestraInstrumentDisplay/>}
                {Object.keys(instrumentsWithAmount).length > MAX_INSTRUMENTS_DISPLAYED ? <a className="error">+{Object.keys(instrumentsWithAmount).length - MAX_INSTRUMENTS_DISPLAYED}</a> : <></>}
            </div> : <></>}
        </div>

    </a>
}

export type { PieceDisplayProps };
